module.exports = __webpack_public_path__ + "static/media/6_angel_naga.33e7757d.png";